export type MultiBankReadResult<T> = {
  n: number;
  ok: boolean;
  list: T[];
};

export function mergeRefreshedBankItems<T extends { id?: unknown }>(
  existing: T[],
  results: MultiBankReadResult<T>[],
  databaseOf: (item: T) => number,
  isManagedDatabase: (database: number) => boolean
): T[] {
  const refreshed = new Set(results.filter(item => item.ok).map(item => item.n));
  const preserved = existing.filter(item => {
    const source = databaseOf(item);
    return !isManagedDatabase(source) || !refreshed.has(source);
  });
  const fresh = results.filter(item => item.ok).flatMap(item => item.list);
  const merged = new Map<string, T>();
  [...preserved, ...fresh].forEach((item, index) => {
    const source = databaseOf(item);
    const id = String(item?.id || `position_${index}`);
    merged.set(`${source || 'legacy'}:${id}`, item);
  });
  return [...merged.values()];
}
